// About.js
import React from 'react';
import '../styles/About.css';

function About() {
  return (
    <section className="about">
      <div className="about-content">
        <h2>Hello!</h2>
	  <p>I am a media professional with over a decade of experience in video production and journalism. My skills include:</p>
	  
          <p><strong>Post-production:</strong> I’ve worked as a professional editor for years now, primarily in digital documentary spaces, and also in some commercial spaces. I use the Adobe Suite (Premiere, After Effects, a bit of Photoshop), and also know Avid Media Composer and DaVinci Resolve.</p>
          <p><strong>Camera work:</strong> I own and operate a Sony FX3 cinema-quality camera, and have a nice bit of kit to fill it out, including lights, audio gear, and a gimbal.</p>
          <p><strong>Researching and writing:</strong> I have spent years working on documentary scripts, and am adept at taking on a load of rushes and finding the story without a paper script.</p>
          <p><strong>Project management:</strong> Setting up meetings, creating kit lists and shot charts, securing filming locations, etc. The “boring” stuff.</p>
          <p><strong>Comedy:</strong> (writing/directing/performing sketch, in live and digital spaces), which may or may not be relevant to the project you’re putting together.</p>
        <p>
          I am currently freelancing and am always looking to take on new and exciting jobs. Get in touch!
        </p>
      </div>
    </section>
  );
}

export default About;
